/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2022-03-18 09:23:09
 * @LastEditTime: 2022-03-21 14:27:55
 * @LastEditors: Yandong Hu
 * @Description:
 */
import React from "react";
import ReactDOM from "react-dom";
import "./global.config.scss";
import { RecoilRoot } from "recoil";
import { Header } from "./pages/header/header";
import { MblockIDE } from "./pages/mblock/mblock";
import { Waiting } from "./pages/waiting/waiting";
import { DialogRename } from "./components/dialog/dialog";
import { LoadingView } from "./components/loading-view/loading-view";

const RootApp = () => {
  return (
    <React.StrictMode>
      <Header></Header>
      <MblockIDE></MblockIDE>
      <DialogRename></DialogRename>
      <LoadingView></LoadingView>
    </React.StrictMode>
  );
};
ReactDOM.render(
  <RecoilRoot>
    <RootApp></RootApp>
  </RecoilRoot>,
  document.getElementById("root")
);
ReactDOM.render(<Waiting></Waiting>, document.getElementById("root2"));
